/*
 * request plus 文档：
 * 方法： get(url, params, options)、post(url, params, options)
 * */

import { hPost, hGet, requestGet } from "@osgfe/tools";

const env = process.env.NODE_ENV || "development";
const protoPrefix = ["development", "test"].includes(env) ? "https" : "https";
const isDev = ["development"].includes(env);
const isProd = ["staging", "production"].includes(env);
const ORIGIN_URL_PROD = `${protoPrefix}://passport.mykeeta.com`;
const ORIGIN_URL_DEV = `${protoPrefix}://passport-i18n.fe.test.sankuai.com`;
const ORIGIN_URL = isProd ? ORIGIN_URL_PROD : ORIGIN_URL_DEV;

function urlStringify(options) {
  const loginQs = Object.keys(options)
    .reduce((memo, key) => memo.concat(`${key}=${options[key]}`), [])
    .join("&");
  return loginQs;
}

function getPassportLoginUrl() {
  const urlPath = "/pc/login";
  const backUrlHost = isDev
    ? "https://rss.osg.test.sankuai.com"
    : window.location.origin;
  const backurl = encodeURIComponent(`${backUrlHost}/selectSupplier.html`);
  const params = {
    token_id: "FCIF7y06CWAn9YJ80Wgnug",
    joinkey: "1101485_2046983214",
    service: "rider",
    cityId: 1010601,
    region: "SA",
    locale: localStorage.getItem("i18nLocale") || "en",
    backurl: backurl,
  };
  return `${ORIGIN_URL}${urlPath}?${urlStringify(params)}`;
}

// 跳转登陆页面
export const goToLogin = () => {
  // 删除localStorage中关于供应商相关的字段
  window.localStorage.removeItem("rss_supplier_id");
  window.localStorage.removeItem("rss_real_supplier_id");
  window.localStorage.removeItem("rss_supplier_name");
  window.localStorage.removeItem("rss_supplier_name_map");
  window.localStorage.removeItem("rss_supplier_org_code");
  window.localStorage.removeItem("rss_supplier_operator_mis");
  const loginUrl = getPassportLoginUrl();
  window.top.location.href = loginUrl;
};

function getWithBody(url, bodyData, callback) {
  var xhr = new XMLHttpRequest();

  xhr.open("GET", url, true);

  // 设置请求头，指定请求体类型
  xhr.setRequestHeader("Content-Type", "application/json");

  xhr.onreadystatechange = function () {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      if (xhr.status >= 200 && xhr.status < 300) {
        // 请求成功，处理响应
        callback(null, xhr.responseText);
      } else {
        // 处理错误
        callback(new Error("Request failed with status: " + xhr.status));
      }
    }
  };

  // 发送请求，将 bodyData 序列化为 JSON 字符串
  xhr.send(JSON.stringify(bodyData));
}

function getData(url, params, callback) {
  var xhr = new XMLHttpRequest();

  // 将参数对象转换为查询字符串
  var queryString = Object.keys(params)
    .map(
      (key) => encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
    )
    .join("&");

  // 将查询字符串附加到 URL
  xhr.open("GET", url + "?" + queryString, true);

  // 设置 withCredentials 属性以发送凭据（如 cookies）
  xhr.withCredentials = true;

  xhr.onreadystatechange = function () {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      if (xhr.status >= 200 && xhr.status < 300) {
        // 请求成功，处理响应
        callback(null, xhr.responseText);
      } else {
        // 处理错误
        callback(new Error("Request failed with status: " + xhr.status));
      }
    }
  };

  xhr.send();
}

export const goToLogout = () => {
  const urlPath = "/api/user/v1/logout/pc/reset-token";
  const prodHost = `${protoPrefix}://passport.mykeeta.com`;
  const devHost = `${protoPrefix}://passport-hk.wpt.test.sankuai.com`;
  const originHost = isProd ? prodHost : devHost;
  // const loginUrl = getPassportLoginUrl();
  const backUrlHost = isDev
    ? "https://rss.osg.test.sankuai.com"
    : window.location.origin;
  const params = {
    type: 10000, // 退出类型 用户主动退出 20000 用户被动退出 40000用户发起换登
    detail: JSON.stringify({ methodDetail: "osg_rider" }),
    // redirect_url: loginUrl,
  };
  const url = `${originHost}${urlPath}`;
  getData(url, params, function (error, response) {
    if (error) {
      console.error("Error:", error);
      window.location.reload();
    } else {
      console.log("Response:", response);
      window.location.href = `${backUrlHost}/selectSupplier.html`;
    }
  });
};

const requestFn = (
  type = "post",
  url = "",
  param = {},
  options = {},
  beforeOpt = {}
) => {
  const supplierId = window.localStorage.getItem("rss_supplier_id");
  if (!supplierId) {
    goToLogin();
    return Promise.reject("没有supplierId");
  }

  let urlComp = url;
  let paramComp = param;
  paramComp.supplierId = supplierId;
  paramComp.checkSupplierAccess = true;
  paramComp.operator =
    window.localStorage.getItem("rss_supplier_operator_mis") || "";
  let optionsComp = options;

  if (typeof url === "object" && url.url) {
    // 兼容原来的写法
    urlComp = url.url;
    paramComp = type === "post" ? url.body || {} : url.params || {};
    if (url.type && url.type === "file") {
      optionsComp.headers = {
        "Content-Type": "multipart/form-data",
      };
    }
    if (url.type && url.type === "form") {
      optionsComp.headers = {
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
      };
    }
    if (url.headers) {
      optionsComp.headers = Object.assign({}, optionsComp.headers, url.headers);
    }
  }
  const requestTarget = type === "post" ? hPost : hGet;
  if (!optionsComp.headers) {
    optionsComp.headers = {};
  }
  optionsComp.headers["osg-login-type"] = "passport";
  return requestTarget(urlComp, paramComp, optionsComp).catch((e) => {
    if (e.data && e.data.code === 5) {
      console.log("api for login");
      goToLogin();
    }
    return Promise.reject(e);
  });
};

export const get = (url = "", param = {}, options = {}, beforeOpt = {}) => {
  return requestFn("get", url, param, options, beforeOpt);
};

export const post = (url = "", param = {}, options = {}, beforeOpt = {}) => {
  return requestFn("post", url, param, options, beforeOpt);
};

/*
使用示例：
* import request from 'request/plus';
* const service = new (request('/api/m/promotion/mapi/cube'))();
* service.get('/detail',params).then(...)
*/
const requestHoc = (prefix = "", beforeOptGlobal = {}) => {
  return class Req {
    get(pathStr = "") {
      let [path, param, options, beforeOpt = {}] = arguments;
      let beforeOptRes = Object.assign({}, beforeOptGlobal, beforeOpt);
      return get.apply(
        null,
        [prefix + "" + path].concat([param, options, beforeOptRes])
      );
    }
    post(pathStr = "", beforeOptGlobal = {}) {
      let [path, param, options, beforeOpt = {}] = arguments;
      let beforeOptRes = Object.assign({}, beforeOptGlobal, beforeOpt);
      return post.apply(
        null,
        [prefix + "" + path].concat([param, options, beforeOptRes])
      );
    }
  };
};

export default requestHoc;
